// extracted by mini-css-extract-plugin
export var cartContainer = "_o8-4";
export var gray = "_o8-1";
export var itemContainer = "_o8-2";
export var itemDetails = "_o8-3";
export var strong = "_o8-0";